module.exports = {
          srcSet: __webpack_public_path__ + "6640ce9c808a61f654ee7c69f243d3a2-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "6640ce9c808a61f654ee7c69f243d3a2-1920.png",width: 1920,height: 649}],
          src: __webpack_public_path__ + "6640ce9c808a61f654ee7c69f243d3a2-1920.png",
          toString:function(){return __webpack_public_path__ + "6640ce9c808a61f654ee7c69f243d3a2-1920.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAcUlEQVR4nGP4//8/AwxvadvH1OXcx7AgtU9xbmC47+vYXEEGhv8Mx/4zMMAUMd7Z/I7xyj4Gxn4PBoZZWhnzltgGL9ij3e4+wTSFdYFdB1whw9c3vxn/T3NlAGlezlVsdIUnQ3enZrp6fWwYS2VKAAMA6hw5Nf2xgl8AAAAASUVORK5CYII=",
          width: 1920,
          height: 649
        }